import React, { Component } from 'react';
import { connect } from 'react-redux';
import i18n from '../../i18next';
import { GridLoader } from 'react-spinners';
import { Alert } from 'reactstrap';

import {
    getOrdersDetails,
    loadRestaurant,
    refund,
    cancelOrder,
    clearSelectedOrder,
    createTicket,
    resendFailedOrder,
    manuallyAcceptOrder,
    addExtraTime,
    getOrderAsPdf,
	clearMessage,
	getRefundHistory
} from '../../actions/index';
import { MESSAGE_LEVEL_SUCCESS } from '../../utils/Constants';
import OrderDetailsContent from '../restaurants/orders/OrderDetailsContent';

class CentralOrdersDetailsScreen extends Component {

    componentDidMount() {//719096
        const { restaurantId, orderId } = this.props.match.params;

        if (restaurantId) {
            this.props.loadRestaurant(restaurantId);
        }
		this.props.getOrdersDetails(orderId);
		this.props.getRefundHistory(orderId);
    }

    renderLoadingContainer() {
		const { loadingIndicator, loadingContainerTransparent } = styles;
		
		if (this.props.loading) {
			return (
				<div style={loadingContainerTransparent}>
                    <div style={loadingIndicator} className='text-center loadingIndicator'>
                        <GridLoader color="#0288d1" size={20} />
                    </div>
                </div>
			);
		} else {
			return (
				<div></div>
			);
		}
	}

    renderMessage() {
		if (this.props.message.text !== undefined && this.props.message.text !== null && this.props.message.text !== '') {

			const successMessage = (this.props.message.level === MESSAGE_LEVEL_SUCCESS);

			if (successMessage) {
				setTimeout(() => {
					this.props.clearMessage();
				}, 3000);
			}

			const color = successMessage ? 'success' : 'danger';
			const dismiss = successMessage ? '' : this.props.clearMessage.bind(this);

			const { alertStyle } = styles;

			return (
				<div style={alertStyle}>
					<Alert color={color} toggle={dismiss}>
						{this.props.message.text}
					</Alert>
				</div>
			);
		} else {
			return (
				<div></div>
			);
		}
	}

    render() {
        return (
            <div>
                <h3 style={{ marginTop: 20, textAlign: 'center' }}>{i18n.t('screens:orderDetailsScreen.orderID')} - {this.props.match.params.orderId}</h3>
                <OrderDetailsContent {...this.props} />
                {this.renderLoadingContainer()}
				{this.renderMessage()}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        orderDetails: state.оrderDetails,
        loading: state.loading,
        message: state.message
    }
}

export default connect(mapStateToProps, { 
    getOrdersDetails, 
    loadRestaurant, 
    refund, 
    cancelOrder, 
    clearSelectedOrder, 
    createTicket, 
    resendFailedOrder, 
    manuallyAcceptOrder, 
    addExtraTime, 
    getOrderAsPdf,
	clearMessage,
	getRefundHistory })(CentralOrdersDetailsScreen);

const styles = {
    alertStyle: {
		position: 'fixed',
		top: '70px',
		left: '0',
		right: '0',
		width: '400px',
		height: '50px',
		marginLeft: 'auto',
		marginRight: 'auto',
		zIndex: 1200
	},
	loadingIndicator: {
        width: '72px',
        height: '72px',
    },
    loadingContainerTransparent: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        textAlign: 'center',
        verticalAlign: 'middle',
        zIndex: 100000000,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
}


// WEBPACK FOOTER //
// ./src/components/central/CentralOrderDetailsScreen.js